<div class="checkbox-container">
  <input type="checkbox" [checked]="params.value" (change)="onChange($event)" (click)="false" />
</div>
